import React from "react";

import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { AvatarInput } from "@dzambalaorg/mui-inputs-image-firebase";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { ContractStatus } from "@framework/types";
import { FormGrid } from "@dzambalaorg/ui-kit";

export { collectionsContractsValidationSchema } from "./validation";

export const Erc721CollectionDialogForm = () => {
  return (
    <FormGrid columns={[2, 1, 3]}>
      <TextInput name="title" />
      <SelectInput name="contractStatus" options={ContractStatus} disabledOptions={[ContractStatus.NEW]} />

      <RichTextEditor name="description" />

      <AvatarInput name="imageUrl" />
      <FormGrid.Empty />
      <FormGrid.Empty />
    </FormGrid>
  );
};
